import { OrdersModel } from '@pukka/api';
import { numberUtils, stringUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

interface ReceiptItemTableProps {
  readonly checkouts: OrdersModel.OrderItem[];
}

function ReceiptItemTable({ checkouts }: ReceiptItemTableProps) {
  return (
    <table className="table-responsive table w-full">
      <tbody>
        {checkouts?.map((checkout) => (
          <tr key={checkout.uuid}>
            <td className="px-4 py-2">
              <div className="flex">
                <div className="flex-1">
                  <Text variant="body-1" color="blue" weight="semibold">
                    {checkout.item_name}
                  </Text>
                  {checkout.item_variant_name && (
                    <Text color="blue" variant="caption-1" className="pl-2">
                      {checkout.item_variant_name}
                    </Text>
                  )}
                  {checkout.modifiers?.map((modifier, i) => (
                    <Text key={i} variant="caption-1" className="pl-2" color="blue">
                      {stringUtils.limitTo(modifier.modifier_name, 15)}
                      {modifier.modifier_name.length > 15 ? '...' : ''} - &nbsp;
                      {stringUtils.limitTo(modifier.modifier_option_name, 15)}
                      {modifier.modifier_option_name.length > 15 ? '...' : ''} - &nbsp;
                      {numberUtils.formatCurrency(modifier.price, 'Rp.')}
                    </Text>
                  ))}
                </div>
                <Text variant="body-1" className="w-24 text-center">
                  x{Math.abs(checkout.quantity)}
                </Text>

                <Text variant="body-1" className="flex-1 text-right">
                  {numberUtils.formatCurrency(checkout.price, 'Rp.')}
                </Text>
              </div>

              {checkout.discounts.length > 0 && (
                <div>
                  {checkout.discounts.map(
                    (discount, i) =>
                      discount.discount_type.toLowerCase() === 'percentage' && (
                        <div key={i} className="flex justify-between">
                          <Text variant="caption-1" className="pl-2 text-left italic">
                            {discount.discount_name} ({parseFloat(discount.discount_percentage as unknown as string)}%)
                          </Text>
                          <Text variant="caption-1" className="text-right italic">
                            {Number.isFinite(-discount.discount_amount) && numberUtils.formatCurrency(-discount.discount_amount, 'Rp.')}
                          </Text>
                        </div>
                      ),
                  )}
                </div>
              )}

              {checkout.note && (
                <Text variant="caption-1" className="pl-2 italic">
                  {checkout.note}
                </Text>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ReceiptItemTable;
